import React from 'react'
import StateLicenseMap from './../../../../components/agents/StateLicenseMap/StateLicenseMap.component'
import { LICENSED_STATE_LICENSES } from './../../../../constants/licensed-states.constants'
import './TestimonialsContent.component.scss'

const TestimonialsContent = () => {
  return (
    <section className='testimonials-content'>
      <div className='testimonials-content__row'>
        <div className='testimonials-content__col testimonials-content__col--left'>
          <p className='testimonials-content__quote'>
            <span>{'\u201CAs a self-employed business owner, I finally have a plan I understand.\u201D'}</span>
          </p>
          <p className='testimonials-content__quote'>
            <span>
              {'\u201CSwitching plans felt overwhelming until USA Benefits Group helped me compare everything.\u201D'}
            </span>
          </p>
        </div>
        <div className='testimonials-content__col testimonials-content__col--center'>
          <StateLicenseMap
            licenses={LICENSED_STATE_LICENSES}
            legend={false}
            clickable={false}
            highlightColor='#1a237e'
          />
        </div>
        <div className='testimonials-content__col testimonials-content__col--right'>
          <p className='testimonials-content__quote'>
            <span>
              {
                '\u201CMy agent still checks in every year to review my coverage and they\u2019re always available when I have questions.\u201D'
              }
            </span>
          </p>
          <p className='testimonials-content__quote'>
            <span>{'\u201CThey found me better coverage for less than I was paying.\u201D'}</span>
          </p>
        </div>
      </div>
    </section>
  )
}

export default TestimonialsContent
